// Types
export const NOTIFICAR_ERRO = 'notificacao/NOTIFICAR_ERRO';
export const NOTIFICAR_SUCESSO = 'notificacao/NOTIFICAR_SUCESSO';

// Reducer

const INITIAL_STATE = {
  notificacaoErro: null,
  notificacaoSucesso: null,
  iconeSucesso: null,
  iconeErro: null,
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case NOTIFICAR_ERRO:
      return {
        ...state,
        notificacaoErro: action.payload.mensagem,
        iconeErro: action.payload.iconeErro,
      };

    case NOTIFICAR_SUCESSO:
      return {
        ...state,
        notificacaoSucesso: action.payload.mensagem,
        iconeSucesso: action.payload.iconeSucesso,
      };

    default:
      return state;
  }
};

// Action creators

export const exibirNotificacao = (mensagem, iconeErro) => ({
  type: NOTIFICAR_ERRO,
  payload: { mensagem, iconeErro },
});

export const exibirNotificacaoSucesso = (mensagem, iconeSucesso) => ({
  type: NOTIFICAR_SUCESSO,
  payload: { mensagem, iconeSucesso },
});
